import React, { useState, useEffect } from 'react';
import './Hero.css';

const roles = ["Web Developer.", "Graphics Designer.", "UI/UX Enthusiast."]; 

function Hero() {
  const prefix = "A ";
  const [roleIndex, setRoleIndex] = useState(0);
  const [typedText, setTypedText] = useState(prefix);
  const [isDeleting, setIsDeleting] = useState(false);
  const [charIndex, setCharIndex] = useState(0);
  const [isStarted, setIsStarted] = useState(false);

  useEffect(() => {
    const startTimeout = setTimeout(() => setIsStarted(true), 500);
    return () => clearTimeout(startTimeout);
  }, []);

  useEffect(() => {
    if (!isStarted) return;
    let typingSpeed = 100;
    let timeout;
    const currentRole = roles[roleIndex];

    if (!isDeleting) {
      if (charIndex < currentRole.length) {
        timeout = setTimeout(() => {
          setTypedText(prefix + currentRole.slice(0, charIndex + 1));
          setCharIndex(charIndex + 1);
        }, typingSpeed);
      } else {
        timeout = setTimeout(() => setIsDeleting(true), 2000);
      }
    } else {
      if (charIndex > 0) {
        timeout = setTimeout(() => {
          setTypedText(prefix + currentRole.slice(0, charIndex - 1));
          setCharIndex(charIndex - 1);
        }, typingSpeed / 2);
      } else {
        timeout = setTimeout(() => {
          setIsDeleting(false);
          setRoleIndex((roleIndex + 1) % roles.length);
        }, 1000);
      }
    }

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, roleIndex, isStarted]); 

  useEffect(() => {
    setCharIndex(0);
  }, [roleIndex]);

  return (
    <section id="home" className="hero hero-row">
      <div>
        <img src="/avatar.jpg" alt="avatar" className="hero-avatar" loading="lazy" />
      </div>
      <div className="hero-content">
        <h1 className="hero-title">Matrika Bhatta</h1>
        <h2 className="hero-subtitle">
          {typedText}
          <span className="typewriter-cursor">|</span>
        </h2>
        <p className="hero-description">
          "I'm Matrika Bhatta, a Frontend Developer and Graphic Designer passionate about creating visually appealing, user-friendly websites and digital experiences that blend creativity with functionality."
        </p>
        <div className="social-icons">
          <a href="https://github.com/MtRiX-x22">
            <img
              src="/github.png"
              alt="Github"
              loading="lazy"
              onMouseOver={e => e.currentTarget.src = "/github (1).png"}
              onMouseOut={e => e.currentTarget.src = "/github.png"}
              style={{ width: "40px", height: "40px" }}
            />
          </a>
          <a href="https://www.linkedin.com/in/matrika-bhatta-59374636b/">
            <img
              src="/linkedin.png"
              alt="LinkedIn"
              loading="lazy"
              onMouseOver={e => e.currentTarget.src = "/linkedin (1).png"}
              onMouseOut={e => e.currentTarget.src = "/linkedin.png"}
              style={{ width: "40px", height: "40px" }}
            />
          </a>
          <a href="https://www.instagram.com/mausam_vatta/">
            <img
              src="/instagram.png"
              alt="Instagram"
              loading="lazy"
              onMouseOver={e => e.currentTarget.src = "/instagram (1).png"}
              onMouseOut={e => e.currentTarget.src = "/instagram.png"}
              style={{ width: "40px", height: "40px" }}
            />
          </a>
          <a href="https://www.facebook.com/profile.php?id=61581482506319">
            <img
              src="/facebook.png"
              alt="Facebook"
              loading="lazy"
              onMouseOver={e => e.currentTarget.src = "/facebook (1).png"}
              onMouseOut={e => e.currentTarget.src = "/facebook.png"}
              style={{ width: "40px", height: "40px" }}
            />
          </a>
        </div>
        <a href="#contact"><button className="hero-button">Contact Me</button></a>
      </div>
    </section>
  );
}

export default Hero;
